import { Gift, Camera, MessageCircle } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { VideoRequestForm } from "@/components/VideoRequestForm";
import { IMAGES } from "@/lib/content";

const STEPS = [
  { icon: Gift, title: "Your first one is on us", body: "Every family receives one complimentary underwater video during their first week of lessons — a little peek at your swimmer's progress below the surface." },
  { icon: Camera, title: "$10 extra per lesson", body: "After that, continued video progress is just $10 extra per lesson. Capture milestones like the first independent swim, a breakthrough day or a birthday lesson." },
  { icon: MessageCircle, title: "Simply request one", body: "Send a request below and Milly will confirm and start filming at your upcoming lessons — $10 is added to each lesson you choose to have filmed." },
];

export default function UnderwaterVideos() {
  return (
    <div data-testid="underwater-videos-page">
      <PageHeader
        overline="Moments below the surface"
        title="Underwater"
        italic="videos."
        subtitle="One complimentary video to see the magic for yourself — then continued video progress for just $10 extra per lesson."
        image={IMAGES.girlSmile}
      />

      <section className="py-16" data-testid="underwater-videos-steps">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div className="p-8 rounded-2xl bg-white border h-full" style={{ borderColor: "rgba(212,175,55,0.25)" }} data-testid={`video-step-${i}`}>
                <s.icon size={26} style={{ color: "var(--gold)" }} />
                <h3 className="font-display text-2xl mt-5 mb-3" style={{ color: "var(--navy)" }}>{s.title}</h3>
                <p className="font-body font-light leading-relaxed" style={{ color: "var(--muted)" }}>{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-start">
          <Reveal>
            <video className="w-full rounded-3xl border aspect-video object-cover bg-black" style={{ borderColor: "rgba(212,175,55,0.3)" }}
              src="/videos/mermaid-sisters.mp4" poster="/videos/mermaid-sisters.jpg" controls playsInline preload="metadata" data-testid="underwater-sample-video" />
            <p className="font-body font-light text-sm mt-4" style={{ color: "var(--muted)" }}>A sample of what an underwater video looks like.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="overline mb-4" style={{ color: "var(--gold)" }}>Request an extra video</p>
            <h2 className="font-display text-4xl md:text-5xl mb-8" style={{ color: "var(--navy)" }}>Keep the memories <span className="italic">coming.</span></h2>
            <VideoRequestForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
